export default {
  computed: {
    get_src() {
      if (!this.src) return
      return `https://www.youtube-nocookie.com/embed/${this.trimmed_youtube_src}&controls=0&autoplay=1`;
    },
    trimmed_youtube_src() {
      if (!this.src) return ''
      let last_index = this.src.lastIndexOf('/');
      return this.src.substring(last_index + 1)
    }
  },
}
